enum CashBoxEventsTypes {
  Transaction = 'transaction',
  Order = 'order',
  Open = 'open',
  Close = 'close',
  PartialClose = 'partial-close',
}

export default CashBoxEventsTypes;
